const CURRENCY = {
  default: 'krw',
  list: [
    // { c: 'krw', n: 'KRW', e: '&#8361;' },
    // { c: 'usd', n: 'USD', e: '&#36;' },
    // { c: 'gbp', n: 'GBP', e: '&#163;' },
    // { c: 'eur', n: 'EUR', e: '&#8364;' }
    { n: 'United States, Dollar', c: 'usd', e: '$' },
    { n: 'Korea (South) Won', c: 'krw', e: '₩' },
    { n: 'Japan Yen', c: 'jpy', e: '¥' },
    { n: 'China Yuan Renminbi', c: 'cny', e: '¥' },
    { n: 'Euro Member Countries', c: 'eur', e: '€' },
    { n: 'Taiwan New Dollar', c: 'twd', e: 'NT$' },
    { n: 'Indonesia Rupiah', c: 'idr', e: 'Rp' },
    { n: 'Thailand Baht', c: 'thb', e: '฿' },
    { n: 'Ukraine Hryvnia', c: 'uah', e: '₴' },
    { n: 'India Rupee', c: 'inr', e: '₹' },
    { n: 'Malaysia Ringgit', c: 'myr', e: 'RM' },
    { n: 'Poland Zloty', c: 'pln', e: 'zł' },
    { n: 'Russia Ruble', c: 'rub', e: '₽' },
    { n: 'Turkey Lira', c: 'try', e: 'TL' },
    { n: 'Viet Nam Dong', c: 'vnd', e: '₫' },
    { n: 'Philippine peso', c: 'php', e: '₱' },
    { n: 'Mongolian Tugrik', c: 'mnt', e: '₮' },
  ],
  currencyInfo: function (currency) {
    return this.currs.filter(x => x.c === currency)[0]
  }
}

export default CURRENCY
